const Toggler = (el) => {
    el.addEventListener('click', (e) => {
        const trigger = e.target;
        trigger.classList.toggle('open')
        const toggledId = trigger.getAttribute('aria-controls');
        document.getElementById(toggledId).classList.toggle('open')
    });
};

export default Toggler;
